module.exports = __webpack_public_path__ + "assets/img/bg1.3c48b222.png";